import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: false,
  state: () => ({
    contextId: undefined,
    programContextId: undefined,
    programContextTypeId: undefined,
    regionContextId: undefined,
  }),
  getters: {
    supportContextId(state, getters, rootState) {
      return state.contextId || rootState.User.companyid;
    },
    supportProgramContextId(state, getters, rootState) {
      return state.programContextId || rootState.User.companyprogramid;
    },
    supportProgramContextTypeId(state) {
      return state.programContextTypeId;
    },
    supportRegionContextId(state, getters, rootState) {
      return state.regionContextId || rootState.User.regionid;
    },
  },
  mutations,
  actions,
};
